import useGlobalContext from '../../hooks/useGlobalContext';
import logo_about from '../../images/s_WSP1.webp';

const About = () => {
  const {logo_sitev, sitevExp} = useGlobalContext();

  window.addEventListener("load", () =>{
    document.querySelector(".main-image-container").classList.add('loaded');
  });

  return (
    <main className="main" id="main">
      <div className="main-container">
        <h1 className="main__title">Sistema Integrado de Inspección Técnica Vehicular</h1>
        <figure className="main-image-container">
          <img src={logo_sitev} fetchpriority="high" width="400" height="267" className="main__image" alt="Logo SITEV"/>
        </figure>
        <h2 className="main__subtitle">Software para CITV - Centros de Inspección Técnica Vehicular</h2>
      </div>
      
      <div className="main-container2">
        <div className="main-container3">
          <div className="main-container-info">
            <h2 className="main__subtitle-info">¿Que es SITEV?</h2>
            <p className="main__details">
              Es un software <b>altamente automatizado</b> para la gestión integral de Centros de Inspección Ténica Vehicular (CITV), que operen lineas Livianas, Pesadas, Mixtas, Combinadas o Menores.<br/><br/>
              Desarrollado bajo las exigencias del Ministerio de Transportes y Comunicaciones - MTC, <b>cumple estrictamente</b> con las Resoluciones Directorales N° 3041-2009-MTC/15 y N° 4801-2017-MTC/15<sup>(1)</sup>
              <br/>
              <br/>
              SITEV es la mejor herramienta de gestión, administración y toma de decisiones para su CITV. Más de {sitevExp} años en el mercado y múltiples casos de éxito nos respaldan.
              <br/>
            </p>
            <figure className="main-image-details-container">
              <img className="main__image-details" height="280" width="275" src={logo_about} alt="SITEV es el software ideal para su CITV" fetchpriority="high"/>
            </figure>
            <p className="main__footnote">
              <sup>(1)</sup>Resoluciones que aprueban las Características y Especificaciones del Sistema Informático y de Comunicaciones para los Centros de Inspección Ténica Vehicular.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
 
export default About;